import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import PouredType from "./PouredType";
import CardsPercentageJob from "./CardsPercentageJob";
import { Flex, notification, Typography, Row, Button } from "antd";
import AfterWorkType from "./AfterWorkType";
import PreviousWorkType from "./PreviousWorkType";
import { RollbackOutlined } from "@ant-design/icons";
const { Text } = Typography;

const PouredJobDetails = ({ match, history }) => {
	const [loading, setLoading] = useState(true);
	const [loadList, setLoadList] = useState([]);
	const [job, setJob] = useState({});
	const [type, setType] = useState(
		localStorage.getItem("pouredRole") === "QC" ? "poured" : "previouswork"
	);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getJob();
	}, []);

	const getJob = async () => {
		try {
			setLoading(true);

			const url =
				api + `/job/addedloads/pouring/57Concrete/get/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.loads.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						deliveryTicket: item.deliveryTicket,
						driver: item.driver,
						truckNumber: item.truckNumber,
						plantSlump: item.plantSlump || "-",
						plantTemperature: item.plantTemperature
							? `${item.plantTemperature} °F`
							: "-",
						date: item.date
							? dayjs(item.date).format("MM/DD/YYYY hh:mm:ss A")
							: "-",
						departure: item.toJobDate
							? dayjs(item.toJobDate)
									.add(6, "h")
									.format("MM/DD/YYYY hh:mm:ss A")
							: "-",
						jobSiteSlump: item.jobSiteSlump || "-",
						jobSiteTemperature: item.jobSiteTemperature
							? `${item.jobSiteTemperature} °F`
							: "-",
						jobSiteDrumRotation: item.jobSiteDrumRotation || "-",
						toJobDate: item.toJobDate
							? dayjs(item.toJobDate)
									.add(6, "h")
									.add(90, "m")
									.format("MM/DD/YYYY hh:mm:ss A")
							: "-",
						jobSiteAmbientTemperature: item.jobSiteAmbientTemperature
							? `${item.jobSiteAmbientTemperature} °F`
							: "-",
					});
				});
				setLoadList(list);
				setJob(data.payload);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderSections = () => {
		return (
			<Flex vertical gap={16}>
				<Flex vertical>
					<Row>
						<Text strong style={{ fontSize: 18 }}>
							Job Number:
						</Text>
						&nbsp;
						<Text style={{ fontSize: 18 }}>{` ${job.number}`}</Text>
					</Row>
					<Row>
						<Text strong style={{ fontSize: 18 }}>
							Customer:
						</Text>
						&nbsp;
						<Text style={{ fontSize: 18 }}>{` ${job.customer.name}`}</Text>
					</Row>
					<Row>
						<Text strong style={{ fontSize: 18 }}>
							Date:
						</Text>
						&nbsp;
						<Text style={{ fontSize: 18 }}>{` ${dayjs(job.scheduledDate).format(
							"MM/DD/YYYY hh:mm:ss A"
						)}`}</Text>
					</Row>
				</Flex>
				<CardsPercentageJob job={job} action={setType} type={type} />
				{type === "previouswork" && <PreviousWorkType job={job} />}
				{type === "poured" && <PouredType loads={loadList} history={history} />}
				{type === "afterwork" && <AfterWorkType job={job} />}
			</Flex>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="Job Details" description="">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
					loading={loading}
					disabled={loading}
				/>
				{loading ? <CustomSpinner /> : <RenderSections />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default PouredJobDetails;
